import React, { useEffect, useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Import styles
import './Editor.css'

const TextEditor = ({ onChange, values }) => {

    const handleChange = (content, delta, source, editor) => {
        onChange(content)
    };

    return (
        <div className='py-5'>
            <ReactQuill className='h-48'
                value={values}
                onChange={handleChange}
                modules={TextEditor.modules}
                formats={TextEditor.formats}
            />
        </div>
    );
};

// Modules and formats configuration for Quill editor
TextEditor.modules = {
    toolbar: [
        [{ header: '1' }, { header: '2' }, { font: [] }],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ color: [] }, { background: [] }],
        [{ script: 'super' }, { script: 'sub' }],
        ['blockquote', 'code-block'],
        [{ align: [] }],
        ['link', 'image'],
        ['clean'],
    ],
};

TextEditor.formats = [
    'header',
    'font',
    'size',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'indent',
    'link',
    'image',
    'video',
    'color',
    'background',
    'align',
    'code-block',
];

export default TextEditor;
